import { render } from "./QualityNotificationCard.vue?vue&type=template&id=2d231744&scoped=true"
import script from "./QualityNotificationCard.vue?vue&type=script&lang=js"
export * from "./QualityNotificationCard.vue?vue&type=script&lang=js"

import "./QualityNotificationCard.vue?vue&type=style&index=0&id=2d231744&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d231744"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QExpansionItem,QCardSection,QBanner,QBtn,QSpinner,QForm,QIcon,QSpace});
